import { render, staticRenderFns } from "./ChartEditColumnLabels.vue?vue&type=template&id=77fd6b10"
import script from "./ChartEditColumnLabels.vue?vue&type=script&lang=js"
export * from "./ChartEditColumnLabels.vue?vue&type=script&lang=js"
import style0 from "./ChartEditColumnLabels.vue?vue&type=style&index=0&id=77fd6b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports